import facefusionIcon from '../assets/icons/authors/facefusion.png';
import xueshuIcon from '../assets/icons/authors/xueshu.jpg';
import aifunIcon from '../assets/icons/authors/aifun.png';
import localaiIcon from '../assets/icons/authors/localai.png';
import sideincomeIcon from '../assets/icons/authors/sideincome.png';
import patreonIcon from '../assets/icons/authors/patreon.jpg';
import patreon1Icon from '../assets/icons/authors/patreon1.png';

export const authorIconMapping = {
    "https://facefusion.site": facefusionIcon,
    "https://xueshu.fun": xueshuIcon,
    "https://aifun.fans": aifunIcon,
    "https://sideincome.online": sideincomeIcon,
    "https://localai.top": localaiIcon,
    "https://patreon.com/localai": patreonIcon,
    "https://patreon.com/UncensoredAI123": patreon1Icon
};

export default authorIconMapping;
